exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legalText[data-v-b6d95224]{font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif;font-size:.8125rem;color:#fff;color:#879baa;padding:0 16px}", ""]);

// exports
